import { useMemo } from 'react';

import { adminBroadcastNotification } from '@pharmaplan/common';

import {
  emptyScheduleValues,
  isUpcomingSchedule,
  toScheduleValues,
} from '../../../components/Admin/BroadcastList/CreateEditBroadcastNotification/BroadcastFields/BroadcastScheduleFields/helper';
import { useAppSelector } from '../../useAppSelector';

// A NOTIFICATION BEING EDITED STAYS SCHEDULABLE ONLY WHILE ITS SEND TIME IS STILL AHEAD
const useBroadcastEditSchedule = (isEdit: boolean) => {
  const { sendAt } = useAppSelector(adminBroadcastNotification);
  const storedSendAt = sendAt ?? null;

  // DECIDED ONCE PER LOADED NOTIFICATION, SO THE FORM DOES NOT CHANGE SHAPE MID EDIT
  const isUpcoming = useMemo(
    () =>
      isEdit && isUpcomingSchedule(storedSendAt),
    [isEdit, storedSendAt],
  );

  // MEMOIZED SO FORMIK'S REINITIALIZE SEES THE SAME VALUES ON EVERY RENDER
  const scheduleValues = useMemo(
    () =>
      (isUpcoming ? toScheduleValues(storedSendAt) : emptyScheduleValues),
    [isUpcoming, storedSendAt],
  );

  return {
    scheduleValues,
    isScheduleVisible: !isEdit || isUpcoming,
    isUpdateVisible: isUpcoming,
  };
};

export default useBroadcastEditSchedule;
